import React, { useState } from "react";
import "../Assets/Styles/form.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const GMA = () => {
  const [formData, setFormData] = useState({
    sl: "",
    ph: "",
    slFr: "",
    phFr: "",
    body: "",
    cta: "",
    trackingCode: "",
    ctaUrl: "",
    heroOneUrl: "",
    heroTwoUrl: "",
    heroThreeUrl: "",
    hero: "",
    heroUrl: "",
    tileTwoImg: "",
    tileThreeImg: "",
    showDiv: "No",
    hasBanner: "",
    heroFr: "",
    heroFrUrl: "",
    tileFourImg: "",
    iconOneEn: "",
    iconTwoEn: "",
    iconThreeEn: "",
    iconOneFr: "",
    iconTwoFr: "",
    iconThreeFr: "",
  });

  const [showPreview, setShowPreview] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];
    if (file) {
      const fileName = file.name;
      const fileUrl = URL.createObjectURL(file);
      setFormData({ ...formData, [name]: { fileName, fileUrl } });
    }
  };

  const heroFileName = formData.hero?.fileName;
  const ctaFileName = formData.cta?.fileName;
  const heroFileNameFr = formData.heroFr?.fileName;
  const iconOneEnFileName = formData.iconOneEn?.fileName;
  const iconTwoEnFileName = formData.iconTwoEn?.fileName;
  const iconThreeEnFileName = formData.iconThreeEn?.fileName;
  const iconOneFrFileName = formData.iconOneFr?.fileName;
  const iconTwoFrFileName = formData.iconTwoFr?.fileName;
  const iconThreeFrFileName = formData.iconThreeFr?.fileName;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setShowPreview(true);
    saveAsHtmlFile()
  };

  const replaceFrenchCharacters = (text) => {
    const replacements = {
      é: "&eacute;",
      è: "&egrave;",
      ê: "&ecirc;",
      à: "&agrave;",
      ç: "&ccedil;",
      î: "&icirc;",
      ï: "&iuml;",
      ô: "&ocirc;",
      ù: "&ugrave;",
      û: "&ucirc;",
    };
    return text.replace(
      /[\u00E0-\u00FC]/g,
      (char) => replacements[char] || char
    );
  };

  const saveAsHtmlFile = async () => {
    const { sl, ph, slFr, phFr, body, trackingCode, heroFr, heroFrUrl, ctaUrl, hasBanner, heroOneUrl, heroTwoUrl, heroThreeUrl, showDiv, heroUrl, tileFourImg } = formData;

    const safeSl = replaceFrenchCharacters(sl);
    const safePh = replaceFrenchCharacters(ph);
    const safeSlFr = replaceFrenchCharacters(slFr);
    const safePhFr = replaceFrenchCharacters(phFr);
    const safeBody = replaceFrenchCharacters(body);
    const fileName = trackingCode ? `${trackingCode.replace(/\s+/g, "_")}` : "Generated_email.html";

    const cvHtml = `
        
         <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml"
xmlns:v="urn:schemas-microsoft-com:vml"
xmlns:o="urn:schemas-microsoft-com:office:office">
<head>
<title>${safeSl} | ${safeSlFr}</title>
<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0" />
<meta name="format-detection" content="telephone=no"/>
<meta name="x-apple-disable-message-reformatting" content=""/>
<!--[if !mso]><!-->
<link type="text/css" href="https://fonts.googleapis.com/css?family=Roboto+Condensed:300,400,700" rel="stylesheet"  />
<link type="text/css" href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap" rel="stylesheet" />
<!--<![endif]-->

<style type="text/css">
a[href^="x-apple-data-detectors:"] {
    color: inherit;
    text-decoration: inherit;
}
.appleLinks a {
    color: #000000;
    text-decoration: none;
}
.appleLinksWhite a {
    color: #ffffff;
    text-decoration: none;
}
.samsungLinks a {
    color: #666666;
    text-decoration: none;
}
body {
    margin: 0 auto !important;
    padding: 0 !important;
    -webkit-text-size-adjust: 100% !important;
    -ms-text-size-adjust: 100% !important;
    -webkit-font-smoothing: antialiased !important;
}
img {
    border: 0 !important;
    outline: none !important;
}
table {
    border-collapse: collapse;
    mso-table-lspace: 0px;
    mso-table-rspace: 0px;
}
td, a, span {
    border-collapse: collapse;
    mso-line-height-rule: exactly;
}
.ExternalClass * {
    line-height: 100%;
}
.em_defaultlink a {
    color: inherit !important;
    text-decoration: none !important;
}
span.MsoHyperlink {
    mso-style-priority: 99;
    color: inherit;
}
span.MsoHyperlinkFollowed {
    mso-style-priority: 99;
    color: inherit;
}
input {
    display: none !important;
}
/* CSS for hiding content in desktop/webmail clients */
.imghide {
    max-height: 0px;
    font-size: 0;
    display: none;
    overflow: hidden;
}

@media only screen and (min-width:481px) and (max-width:549px) {
.desk-visible {
    display: none;
}
.showmenu {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: normal !important;
    margin-top: 0px !important;
    visibility: inherit !important;
    border-bottom: 0 !important;
}
*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
}
*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
}
*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
}
.em_main_table {
    width: 100% !important;
}
.em_wrapper {
    width: 100% !important;
}
.em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    font-size: 20px !important;
    border-top: 1px solid #ffffff;
}
.em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    font-size: 20px !important;
}
.em_side {
    width: 10px !important;
}
.em_hide {
    width: 100% !important;
    height: auto !important;
}
.em_img {
    width: 100% !important;
    height: auto !important;
}
.em_center {
    text-align: center !important;
}
.em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
}
.em_pad {
    padding-top: 20px !important;
}
.em_aside {
    padding: 0 10px !important;
}
.em_topbom {
    padding: 20px 0px !important;
}
div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
}
.em_f60 {
    font-size: 70px !important;
    line-height: 72px !important;
}
.em_f40 {
    font-size: 42px !important;
    line-height: 42px !important;
}
.em_h10 {
    height: 10px !important;
}
.em_h40 {
    height: 40px !important;
}
.em_h30 {
    height: 30px !important;
}
.em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.em_hide1 {
    display: none !important;
}
.em_max375 {
    max-width: 375px !important;
}
}

@media screen and (max-width: 480px) {
.desk-visible {
    display: none;
}
.showmenu {
    display: block !important;
    width: auto !important;
    overflow: visible !important;
    float: none !important;
    max-height: inherit !important;
    max-width: inherit !important;
    line-height: normal !important;
    margin-top: 0px !important;
    visibility: inherit !important;
    border-bottom: 0 !important;
}
*[id]#nav_menu {
    background-color: #2a333b;
    max-height: 0;
    overflow: hidden;
    transition: max-height .25s linear;
}
*[id]#nav_handle {
    background: url("menu_icon_sprite.png") 0 0 no-repeat;
    background-size: 23px 36px !important;
    cursor: pointer;
    display: block !important;
    width: 23px !important;
    height: 18px !important;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
*[id]#em_drop:checked + div table #nav_handle {
    background: url("menu_icon_sprite.png") 0 -18px no-repeat;
}
*[id]#em_drop:checked ~ #nav_menu {
    display: block !important;
    max-height: 300px !important;
}
.em_main_table {
    width: 100% !important;
}
.em_wrapper {
    width: 100% !important;
}
.em_wrapper2 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 50px !important;
    border-top: 1px solid #ffffff;
    font-size: 20px !important;
}
.em_wrapper3 {
    width: 100% !important;
    display: block !important;
    text-align: center !important;
    line-height: 40px !important;
    font-size: 20px !important;
}
.em_side {
    width: 10px !important;
}
.em_hide {
    display: none !important;
}
.em_img {
    width: 100% !important;
    height: auto !important;
}
.em_center {
    text-align: center !important;
}
.em_h20 {
    height: 20px !important;
    font-size: 0px !important;
    line-height: 0px !important;
}
.em_pad {
    padding-top: 20px !important;
}
.em_aside {
    padding: 0 10px !important;
}
u + .em_body .em_full_wrap {
    width: 100% !important;
    width: 100vw !important;
}
.em_topbom {
    padding: 20px 0px !important;
}
div[class=em_hide_desktop] {
    display: table !important;
    float: none !important;
    width: 100% !important;
    overflow: visible !important;
    height: auto !important;
}
.em_f60 {
    font-size: 55px !important;
    line-height: 58px !important;
}
.em_f40 {
    font-size: 34px !important;
    line-height: 34px !important;
}
.em_h10 {
    height: 10px !important;
}
.em_h40 {
    height: 40px !important;
}
.em_h30 {
    height: 30px !important;
}
.em_br {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.em_hide1 {
    display: none !important;
}
.em_font12 {
    font-size: 10px !important;
    line-height: 14px !important;
}
.em_max375 {
    max-width: 375px !important;
}
.imghide {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
}
*[class].width414 {
    width: 414px !important;
}
*[class].heightAuto {
    height: auto !important;
}
}

@media screen and (max-width: 414px) {
.desk-visible {
    display: none;
}
.imghide414 {
    max-height: none !important;
    font-size: 12px !important;
    display: block !important;
}
.em_hide414 {
    display: none !important;
}
.em_br414 {
    display: block !important;
    padding: 0 0 5px 0 !important;
}
.borders {
    border-left: 2px #333;
}
}
</style>
<!--[if gte mso 9]><xml>
<o:OfficeDocumentSettings>
<o:AllowPNG/>
<o:PixelsPerInch>96</o:PixelsPerInch>
</o:OfficeDocumentSettings>
</xml><![endif]-->
</head>
<body class="em_body" style="margin:0px; padding:0px;" bgcolor="#ffffff">
 
<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
 <tr>
    <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        
        <!-- A03 HEADER SECTION -->
        <tr>
          <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
              <tr>
                <td align="center" valign="top" bgcolor="#000000" style="padding:0 10px;"><table width="530" border="0" cellspacing="0" cellpadding="0" align="center" style="width:530px;" class="em_wrapper">
                    
                    <!-- HEADER SECTION -->
                    <tr>
                      <td class="em_topbom" style="PADDING-BOTTOM: 22px; PADDING-TOP: 5px; PADDING-LEFT: 0px; PADDING-RIGHT: 0px" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
                          <tbody>
                            <!-- PREHEADER SECTION -->
                            <tr>
                              <td align="center" valign="top" style="padding:4px 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                  <tr>
                                    <td align="center" valign="top" style="font-family: 'Arial', sans-serif; font-size:11px; line-height:14px; color:#ffffff;">${safePh}</td>
                                  </tr>
                                </table></td>
                            </tr>
                            <!-- //PREHEADER SECTION -->
                            <tr>
                              <td align="center" valign="top" class="em_topbom" style="padding:24px 0 0 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                                  <tr>
                                    <td align="center" valign="top"><a href="https://www.grainger.ca?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="GraingerCanada_Black-Red_RGB-1280x1280.png" width="230" height="53" alt="logo" title="logo" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#ffffff; font-weight:bold; max-width:230px;" /></a></td>
                                  </tr>
                                </table></td>
                            </tr>
                          </tbody>
                        </table></td>
                    </tr>
                    
                    <!-- //HEADER SECTION -->
                    
                  </table></td>
              </tr>
              
              <!-- NAVIGATION MENU -->
              <tr>
                <td bgcolor="#2a333b" valign="top" align="center"><table class="em_wrapper" style="TABLE-LAYOUT: fixed" cellspacing="0" cellpadding="0" width="550" align="center" border="0">
                    <tbody>
                      <tr>
                        <td valign="middle" align="center"><!--[if !mso]><!-->
                          <input id="em_drop" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none !important; LINE-HEIGHT: 0; MAX-HEIGHT: 0px" type="checkbox"/>
                          <div class="showmenu" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none; LINE-HEIGHT: 0; MAX-HEIGHT: 0px">
                            <table style="MARGIN: 0px auto" cellspacing="0" cellpadding="0" align="center" border="0">
                              <tbody>
                                <tr>
                                  <td height="50" valign="middle" align="center"><label id="nav_handle" for="em_drop"></label></td>
                                  <td style="WIDTH: 10px" width="10">&nbsp;</td>
                                  <td style="FONT-SIZE: 20px; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff" height="50" valign="middle" align="center"><label for="em_drop">MENU</label></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--<![endif]-->
                          
                          <div id="nav_menu" style="MARGIN-LEFT: 0px; Z-INDEX: 50; MARGIN-RIGHT: 0px"><!--<![endif]--><!--[if gte mso 9]>
    <table width="550" border="0" cellspacing="0" cellpadding="0" align="left" class="em_wrapper">
    <tr>
    <td height="50" valign="middle" align="center" width="150">
    <![endif]--><a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; TEXT-TRANSFORM: uppercase; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/&amp;cm_mmc=${trackingCode}"><span 
      class="em_hide">&nbsp; </span>MY ACCOUNT</a><!--[if gte mso 9]>
    </td>
    <td height="50" valign="middle" align="center" width="150">
    <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/category/c/1?cm_mmc=${trackingCode}">ALL PRODUCTS</a><!--[if gte mso 9]>
    </td>
    <td height="50" valign="middle" align="center" width="150">
    <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 145px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/orderHistory&amp;cm_mmc=${trackingCode}">ORDER 
                            HISTORY</a><!--[if gte mso 9]>
    </td>
    <td height="50" valign="middle" align="center">
    <![endif]--> 
                            <a class="em_wrapper2" style="FONT-SIZE: 14px; TEXT-DECORATION: none; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; WIDTH: 100px; FLOAT: left; FONT-WEIGHT: bold; COLOR: #ffffff; DISPLAY: inline-block; LINE-HEIGHT: 50px" href="https://www.grainger.ca/en/cart?from=/fr/cat%C3%A9gorie/c/1?analytics=nav&amp;aType=brc&amp;cm_mmc=${trackingCode}">CART<span 
      class="em_hide">&nbsp;</span></a><!--[if gte mso 9]>
    </td>
    </tr>
    </table>
    <![endif]--> 
                          </div></td>
                      </tr>
                    </tbody>
                  </table></td>
              </tr>
              <!-- //NAVIGATION MENU -->
            </table></td>
        </tr>
      </table></td>
  </tr>
</table>

<table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
	 <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#FFFFFF">
        <tbody>
          <tr>
            <td><a href="${heroUrl}?cm_mmc=${trackingCode}"><img src="${heroFileName}" alt="hero" width="550" height="405" style="font-family: 'Arial', sans-serif; font-size: 22px; width: 550px; color: #000000; display: block;" title="hero" border="0"/></a></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
</table>
<table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#8C1818">
  <tr>
  <td valign="top" align="center"><table width="550" height="15" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
    <tbody>
      <tr>
        <td height="15" style="height:15px;"></td>
      </tr>
    </tbody>
  </table></td>
</tr>
	<tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><img src="${iconOneEnFileName}"  alt="ban4" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></td>
        <td valign="top"><img src="${iconTwoEnFileName}"  alt="ban2" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></td>
        <td valign="top"><img src="${iconThreeEnFileName}"  alt="ban3" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></td>
      </table>
	  </td>
  </tr>
  <tr>
    <td height="12" style="height:12px;"></td>
  </tr>
  <tr>
    <td height="24" style="height:24px;" align="center"><a href="https://www.grainger.ca/en/content/industries?cm_mmc=${trackingCode}"><img src="Learn more CTA.png" width="170" height="42" alt="fhero"  style="margin-top: 10px;"/></a><br>
    <br></td>
  </tr>
  <tr>
    <td height="12" style="height:12px;"></td>
  </tr>
</table>

<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
    <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="https://www.grainger.ca/en/content/industries/manufacturing?cm_mmc=${trackingCode}"><img src="Manufacturing.png"  alt="ban2" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/en/content/industries/healthcare?cm_mmc=${trackingCode}"><img src="Healthcare.png"  alt="ban3" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/en/content/industries/education?cm_mmc=${trackingCode}"><img src="HigherEducation.png"  alt="ban4" width="184" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  </tbody>
</table>
	<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
    <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="https://www.grainger.ca/en/content/industries/government?cm_mmc=${trackingCode}"><img src="Government.png"  alt="ban2" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/en/content/industries/aviation?cm_mmc=${trackingCode}"><img src="Aviation.png"  alt="ban3" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/en/content/industries/food-beverage?cm_mmc=${trackingCode}"><img src="FoodAndBeverage.png"  alt="ban4" width="184" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  </tbody>
</table>
<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
	<tr>
                <td height="10" style="height:10px;" >&nbsp;</td>
              </tr>
	<tr>
                <td align="center" valign="top"  style="font-family: 'Arial', sans-serif; font-size:18px; color:#000000; padding:0 50px;"><p style="margin: 0; padding: 0; margin-bottom: 20px;"><b>Explore our recommended product categories</b>&nbsp;</p></td>
    </tr>
    <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="https://www.grainger.ca/en/category/electrical/c/1006?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="Electrical.png"  alt="ban2" width="138" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
		<td valign="top"><a href="https://www.grainger.ca/en/category/hvac-and-refrigeration/c/1012?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="HVAC.png"  alt="ban3" width="137" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
        <td valign="top"><a href="https://www.grainger.ca/en/category/lighting/c/1016?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="Lighting.png"  alt="ban4" width="137" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
        <td valign="top"><a href="https://www.grainger.ca/en/category/plumbing/c/1022?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="Plumbing.png"  alt="ban2" width="137" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  <tr>
                <td height="10" style="height:10px;" >&nbsp;</td>
              </tr>
	<tr>
  </tbody>
</table>
<table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
  <!-- F01 SOCIAL SECTION -->
  <tbody>
    <tr>
      <td 
          style="PADDING-BOTTOM: 25px; PADDING-TOP: 25px; PADDING-LEFT: 10px; PADDING-RIGHT: 10px" 
          bgcolor="#2a333b" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
          <tbody>
            <tr>
              <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.facebook.com/GraingerCanada/?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="facebook" 
                  src="http://t.e1.acklands.grainger.com/res/img/BBD24EC070059605A9645A5DFE160806.png" 
                  width="45" height="45"/></a></td>
              <td style="WIDTH: 20px" width="20">&nbsp;</td>

              <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.youtube.com/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="youtube" 
                  src="http://t.e1.acklands.grainger.com/res/img/2894A2E9B556F7DB16FF117A20426EE1.png" 
                  width="45" height="45"/></a></td>
              <td style="WIDTH: 20px" width="20">&nbsp;</td>
              <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://ca.linkedin.com/company/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="linkedin" 
                  src="http://t.e1.acklands.grainger.com/res/img/7A31981414EDAE346169F26E55381B00.png" 
                  width="45" height="45"/></a></td>
            </tr>
          </tbody>
        </table></td>
    </tr>
    <!-- //F01 SOCIAL SECTION --> 
    <!-- F02 FOOTER SECTION -->
    <tr>
      <td 
          style="PADDING-BOTTOM: 0px; PADDING-TOP: 0px; PADDING-LEFT: 30px; PADDING-RIGHT: 30px" 
          bgcolor="#000000" valign="top" align="center"><table class="em_wrapper" style="WIDTH: 490px" cellspacing="0" 
            cellpadding="0" width="490" align="center" border="0">
          <tbody>
            <tr>
              <td class="em_defaultlink em_pad" 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 38px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="center"><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}">My Account</a><span 
                  class="em_br414"></span><span class="em_hide414"> &nbsp;|&nbsp; </span><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/contact-us?cm_mmc=${trackingCode}">Contact 
                Us</a> &nbsp;|&nbsp;<span></span><a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/find-branch-location?cm_mmc=${trackingCode}"> Find a Branch</a> &nbsp;|&nbsp; <a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/content/policies/privacy-policy?cm_mmc=${trackingCode}">Privacy 
                Policy</a> &nbsp;|&nbsp; <a style="TEXT-DECORATION: none; WHITE-SPACE: nowrap; COLOR: #ffffff" href="https://www.grainger.ca/en/emailSignUp/unsubscribe?email=<%=recipient.email%>&cm_mmc=${trackingCode}">Unsubscribe</a></td>
            </tr>
            <tr>
              <td 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 15px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="left"><br/>
                <font color="#ffffff">This email was sent to &lt;%= recipient.email %&gt;</font>.<br />
                <br/>
                To ensure delivery to your inbox, add <a href="mailto:grainger@b.grainger.ca" target="_top" style="color: #ffffff !important; text-decoration:none !important;"><font color="#ffffff">grainger@b.grainger.ca</font></a> to your address&nbsp;book.<br/>
                <br/>
                *On most in-stock orders placed by 5 PM (local shipping facility time) to most metropolitan areas, subject to carrier availability. Deliveries occur Monday–Friday, excluding holidays.
                <br/>         
                <p>
                <a href="https://www.grainger.ca/en/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration: underline; color: inherit !important;"><font color="#ffffff">Questions</font></a>? Our Customer Service Centre is here to help you manage your orders, update&nbsp;an existing order, and place new ones.<br/>
                <br/>
                Acklands-Grainger Inc. &ldquo;Grainger&rdquo; &ldquo;Grainger Canada&rdquo; is a distributor of MRO products to businesses, and such products are to be used for business purposes only. We reserve the&nbsp;right to restrict sales of products unless business verification has been performed.<br/>
                <br/>
                Grainger Canada 123 Commerce Valley Drive East, Suite 700, Thornhill, Ontario&nbsp;L3T&nbsp;7W8</td>
            </tr>
            <tr>
              <td style="HEIGHT: 40px" 
          height="40">&nbsp;</td>
            </tr>
          </tbody>
        </table></td>
    </tr>
    <!-- //F02 FOOTER SECTION -->
    <tr>
      <td class="em_hide" style="line-height:1px;min-width:550px;background-color:#ffffff;"><img alt="" src="http://t.e1.acklands.grainger.com/res/img/F2229E22CDA170C551671E5853235FE1.gif" height="1"  width="550" style="max-height:1px; min-height:1px; display:block; width:550px; min-width:550px;" border="0" /></td>
    </tr>
  </tbody>
</table>



<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
 <tr>
      <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        <!-- A03 HEADER SECTION -->
        <tr>
          <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
            <!-- A03 HEADER SECTION -->
            <tr>
              <td align="center" valign="top"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
                <tr>
                  <td align="center" valign="top" bgcolor="#000000" style="padding:0 10px;"><table width="530" border="0" cellspacing="0" cellpadding="0" align="center" style="width:530px;" class="em_wrapper">
                    <!-- HEADER SECTION -->
                    <tr>
                      <td  style="PADDING-BOTTOM: 22px; PADDING-TOP: 5px; PADDING-LEFT: 0px; PADDING-RIGHT: 0px" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
                        <tbody>
                          <!-- PREHEADER SECTION -->
                          <tr>
                            <td align="center" valign="top" style="padding:4px 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                              <tr>
                                <td align="center" valign="top" style="font-family: 'Arial', sans-serif; font-size:11px; line-height:14px; color:#ffffff;">${safePhFr}</td>
                              </tr>
                            </table></td>
                          </tr>
                          <!-- //PREHEADER SECTION -->
                          <tr>
                            <td align="center" valign="top" class="em_topbom" style="padding:24px 0 0 0;"><table border="0" cellspacing="0" cellpadding="0" align="center">
                              <tr>
                                <td align="center" valign="top"><a href="https://www.grainger.ca/fr?cm_mmc=${trackingCode}" style="text-decoration:none;"><img src="GraingerCanada_Black-Red_RGB-1280x1280.png" width="230" height="53" alt="flogo" title="flogo" border="0" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#ffffff; font-weight:bold; max-width:230px;" /></a></td>
                              </tr>
                            </table></td>
                          </tr>
                        </tbody>
                      </table></td>
                    </tr>
                    <!-- //HEADER SECTION -->
                  </table></td>
                </tr>
                <!-- NAVIGATION MENU -->
                <tr>
                  <td bgcolor="#2a333b" valign="top" align="center"><table class="em_wrapper" style="TABLE-LAYOUT: fixed" cellspacing="0" cellpadding="0" width="550" align="center" border="0">
                    <tbody>
                      <tr>
                        <td valign="middle" align="center"><!--[if !mso]><!-->
                          <input id="em_drop3" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none !important; LINE-HEIGHT: 0; MAX-HEIGHT: 0px" type="checkbox"/>
                          <div class="showmenu" style="OVERFLOW: hidden; WIDTH: 0px; FLOAT: left; DISPLAY: none; LINE-HEIGHT: 0; MAX-HEIGHT: 0px">
                            <table style="MARGIN: 0px auto" cellspacing="0" cellpadding="0" align="center" border="0">
                              <tbody>
                                <tr>
                                  <td height="50" valign="middle" align="center"><label id="nav_handle" for="em_drop3"></label></td>
                                  <td style="WIDTH: 10px" width="10">&nbsp;</td>
                                  <td style="FONT-SIZE: 20px; FONT-FAMILY: 'Roboto Condensed', 'Arial', sans-serif; FONT-WEIGHT: bold; COLOR: #ffffff" height="50" valign="middle" align="center"><label for="em_drop3">MENU</label></td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <!--<![endif]-->
                          <div id="nav_menu3" style="MARGIN-LEFT: 0px; Z-INDEX: 50; MARGIN-RIGHT: 0px">
                            <!--<![endif]-->
                            <!--[if gte mso 9]>
	  <table width="550" border="0" cellspacing="0" cellpadding="0" align="left" class="em_wrapper">
	  <tr>
	  <td height="50" valign="middle" align="center" width="150">
	  <![endif]-->
                            <a href="https://www.grainger.ca/fr/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; width:145px; float:left; display:inline-block; text-transform:uppercase;"><span class="em_hide">&nbsp;</span>MON <br class="desk-visible"/>
                              COMPTE</a>
                            <!--[if gte mso 9]>
                  </td>
                  <td height="50" valign="middle" align="center" width="150">
                  <![endif]-->
                            <a href="https://www.grainger.ca/fr/catégorie/c/1?cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; width:145px; float:left; display:inline-block;">TOUS LES <br class="desk-visible"/>
                              PRODUITS</a>
                            <!--[if gte mso 9]>
                  </td>
                  <td height="50" valign="middle" align="center" width="150">
                  <![endif]-->
                            <a href="https://www.grainger.ca/fr/login?frwdUrlPath=/my-account/orderHistory&cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; width:145px; float:left; display:inline-block;">HISTORIQUE DES COMMANDES</a>
                            <!--[if gte mso 9]>
                  </td>
                  <td height="50" valign="middle" align="center">
                  <![endif]-->
                            <a href="https://www.grainger.ca/fr/cart?from=%2Ffr%2Fcat%25C3%25A9gorie%2Fc%2F1%3Fanalytics%3Dnav%26aType%3Dbrc&cm_mmc=${trackingCode}" class="em_wrapper2" style="font-family: 'Roboto Condensed', 'Arial', sans-serif;font-size:14px;color:#ffffff;font-weight:bold;text-decoration:none;line-height:16px; padding-top:8px; padding-bottom: 8px; float:left; display:inline-block; width:100px;">PANIER D&rsquo;ACHATS<span class="em_hide">&nbsp;</span></a>
                            <!--[if gte mso 9]>

	  </td>
	  </tr>
	  </table>
	  <![endif]-->
                          </div></td>
                      </tr>
                    </tbody>
                  </table></td>
                </tr>
                <!-- //NAVIGATION MENU -->
              </table></td>
            </tr>
          </table></td>
        </tr>
      </table></td>
    </tr>
</table>

<table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
	 <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#FFFFFF">
        <tbody>
          <tr>
            <td><a href="${heroFrUrl}?cm_mmc=${trackingCode}"><img src="${heroFileNameFr}" alt="hero" width="550" height="405" style="font-family: 'Arial', sans-serif; font-size: 22px; width: 550px; color: #000000; display: block;" title="hero" border="0"/></a></td>
          </tr>
        </tbody>
      </table></td>
  </tr>
</table>
<table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper" bgcolor="#8C1818">
  <tr>
  <td valign="top" align="center"><table width="550" height="15" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
    <tbody>
      <tr>
        <td height="15" style="height:15px;"></td>
      </tr>
    </tbody>
  </table></td>
</tr>
	<tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><img src="${iconOneFrFileName}"  alt="ban4" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></td>
        <td valign="top"><img src="${iconTwoFrFileName}"  alt="ban2" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></td>
        <td valign="top"><img src="${iconThreeFrFileName}"  alt="ban3" width="183" height="171" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></td>
      </table>
	  </td>
  </tr>
  <tr>
    <td height="12" style="height:12px;"></td>
  </tr>
  <tr>
    <td height="24" style="height:24px;" align="center"><a href="https://www.grainger.ca/fr/content/industries?cm_mmc=${trackingCode}"><img src="En Savoir Plus CTA.png" width="170" height="42" alt="fhero"  style="margin-top: 10px;"/></a><br>
    <br></td>
  </tr>
  <tr>
    <td height="12" style="height:12px;"></td>
  </tr>
</table>

<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
    <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="https://www.grainger.ca/fr/content/industries/manufacturing?cm_mmc=${trackingCode}"><img src="ManufacturingFr.png"  alt="ban2" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/fr/content/industries/healthcare?cm_mmc=${trackingCode}"><img src="HealthcareFr.png"  alt="ban3" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/fr/content/industries/education?cm_mmc=${trackingCode}"><img src="HigherEducationFr.png"  alt="ban4" width="184" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  </tbody>
</table>
	<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
    <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="https://www.grainger.ca/fr/content/industries/government?cm_mmc=${trackingCode}"><img src="GovernmentFr.png"  alt="ban2" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/fr/content/industries/aviation?cm_mmc=${trackingCode}"><img src="Aviation.png"  alt="ban3" width="183" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
          <td valign="top"><a href="https://www.grainger.ca/fr/content/industries/food-beverage?cm_mmc=${trackingCode}"><img src="FoodAndBeverageFr.png"  alt="ban4" width="184" height="183" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  </tbody>
</table>
<table bgcolor="#ffffff" width="550" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
  <tbody>
	<tr>
                <td height="10" style="height:10px;" >&nbsp;</td>
              </tr>
	<tr>
                <td align="center" valign="top"  style="font-family: 'Arial', sans-serif; font-size:18px; color:#000000; padding:0 20px;"><p style="margin: 0; padding: 0; margin-bottom: 20px;"><b>Explorez  nos cat&eacute;gories de produits recommand&eacute;es</b>&nbsp;</p></td>
    </tr>
    <tr>
    <td valign="top" align="center"><table width="550" border="0" cellspacing="0" cellpadding="0" align="center" style="width:550px;" class="em_wrapper">
        <td valign="top"><a href="https://www.grainger.ca/fr/cat%C3%A9gorie/electrical/c/1006?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="ElectricalFr.png"  alt="ban2" width="138" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
		<td valign="top"><a href="https://www.grainger.ca/fr/cat%C3%A9gorie/hvac-and-refrigeration/c/1012?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="HVACFr.png"  alt="ban3" width="137" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban3" border="0" /></a></td>
        <td valign="top"><a href="https://www.grainger.ca/fr/cat%C3%A9gorie/lighting/c/1016?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="LightingFr.png"  alt="ban4" width="137" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:184px; " title="ban4" border="0" /></a></td>
        <td valign="top"><a href="https://www.grainger.ca/fr/cat%C3%A9gorie/plumbing/c/1022?cm_mmc=${trackingCode}&q=%3AtopSeller%3AinStockAtBranch%3ADC&filterType=shopBy&filterName=Shop+By&filterValue=DC&isWildCard=false&type=category&cptype=category"><img src="PlumbingFr.png"  alt="ban2" width="137" height="137" style="display:block; font-family: 'Arial', sans-serif; font-size:16px; line-height:20px; color:#000000; max-width:183px; " title="ban2" border="0" /></a></td>
      </table>
	  </td>
  </tr>
  <tr>
                <td height="10" style="height:10px;" >&nbsp;</td>
              </tr>
	<tr>
  </tbody>
</table>
<table width="100%" border="0" cellspacing="0" cellpadding="0" class="em_full_wrap" bgcolor="#ffffff">
  <tbody>
	<tr>
     
    </tr>
    <tr>
      <td align="center" valign="top"><table align="center" width="550" border="0" cellspacing="0" cellpadding="0" class="em_main_table" style="width:550px; table-layout:fixed;">
        <!-- F01 SOCIAL SECTION -->
        <tbody>
          <tr>
            <td 
          style="PADDING-BOTTOM: 25px; PADDING-TOP: 25px; PADDING-LEFT: 10px; PADDING-RIGHT: 10px" 
          bgcolor="#2a333b" valign="top" align="center"><table cellspacing="0" cellpadding="0" align="center" border="0">
              <tbody>
                <tr>
                  <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.facebook.com/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="ffacebook" src="http://t.e1.acklands.grainger.com/res/img/BBD24EC070059605A9645A5DFE160806.png" 
                  width="45" height="45"/></a></td>
                  <td style="WIDTH: 20px" width="20">&nbsp;</td>
                  <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://www.youtube.com/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="fyoutube" src="http://t.e1.acklands.grainger.com/res/img/2894A2E9B556F7DB16FF117A20426EE1.png" 
                  width="45" height="45"/></a></td>
                  <td style="WIDTH: 20px" width="20">&nbsp;</td>
                  <td valign="middle" align="center"><a style="TEXT-DECORATION: none" href="https://ca.linkedin.com/company/graingercanada?cm_mmc=${trackingCode}"><img 
                  style="FONT-SIZE: 16px; MAX-WIDTH: 50px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; DISPLAY: block; LINE-HEIGHT: 50px" 
                  border="0" alt="flinkedin" src="http://t.e1.acklands.grainger.com/res/img/7A31981414EDAE346169F26E55381B00.png" 
                  width="45" height="45"/></a></td>
                </tr>
              </tbody>
            </table></td>
          </tr>
          <!-- //F01 SOCIAL SECTION -->
          <!-- F02 FOOTER SECTION -->
          <tr>
            <td align="center" valign="top" bgcolor="#000000" style="padding:0 30px;"><table width="490" border="0" cellspacing="0" cellpadding="0" align="center" style="width:490px;" class="em_wrapper">
              <tr>
                <td align="center" valign="top" class="em_defaultlink em_pad" style="font-family: 'Arial', sans-serif; font-size:12px; line-height:16px; color:#ffffff; font-weight:bold; padding:38px 0 0 0;"><a href="https://www.grainger.ca/fr/login?frwdUrlPath=/my-account/&cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Mon compte</font></a><span class="em_br414"></span><span class="em_hide414"> &nbsp;|&nbsp;<a href="https://www.grainger.ca/fr/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;"> Contactez nous</font></a> &nbsp;|&nbsp; </span><a href="https://www.grainger.ca/fr/content/find-branch-location#?cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Trouver une succursale</font></a> &nbsp;|<br>
                  &nbsp; <a href="https://www.grainger.ca/fr/content/policies/privacy-policy?cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">Politique de confidentialit&eacute;</font></a> &nbsp;|&nbsp; <a href="https://www.grainger.ca/fr/emailSignUp/unsubscribe?email=<%=recipient.email%>&cm_mmc=${trackingCode}" style="text-decoration:none; color:#ffffff; white-space:nowrap;"><font color="#ffffff" style="text-decoration: none;">D&eacute;sinscrire</font></a></td>
              </tr>
              <tr>
                <td 
                style="FONT-SIZE: 12px; FONT-FAMILY: 'Arial', sans-serif; COLOR: #ffffff; PADDING-BOTTOM: 0px; PADDING-TOP: 15px; PADDING-LEFT: 0px; LINE-HEIGHT: 16px; PADDING-RIGHT: 0px" 
                valign="top" align="left"><p><br />
                  <font color="#ffffff">Ce courriel &agrave; &eacute;t&eacute; envoy&eacute; &agrave; &lt;%= recipient.email %&gt;</font>.<br />
                  <br />
                  Pour garantir la livraison dans votre bo&icirc;te aux lettres &eacute;lectronique, ajoutez <a href="mailto:grainger@b.grainger.ca" target="_top" style="color: #ffffff !important; text-decoration:none !important;"><font color="#ffffff">grainger@b.grainger.ca</font></a> &agrave; votre carnet d&#39;adresses &eacute;lectroniques.</p>
                  *Pour la plupart des commandes de stock pass&eacute;es avant 17 h (heure locale de l’installation d’exp&eacute;dition) dans la plupart des r&eacute;gions m&eacute;tropolitaines, sous r&eacute;serve
                  de la disponibilit&eacute; des transporteurs. Les livraisons ont lieu du lundi au vendredi, a l’exception des jours f&eacute;ri&eacute;s.
                  <p> <a href="https://www.grainger.ca/fr/content/contact-us?cm_mmc=${trackingCode}" style="text-decoration: underline; color: inherit !important;"><font color="#ffffff">Questions</font></a>? Notre centre de service &agrave; la client&egrave;le est l&agrave; pour vous aider &agrave; g&eacute;rer vos commandes, &agrave; mettre &agrave; jour une commande existante et &agrave; en passer de nouvelles.<br />
                    <br />
                    Acklands-Grainger Inc. “Grainger” “Grainger Canada” est un distributeur de produits MRE aux entreprises, les produits doivent donc &ecirc;tre utilis&eacute;s &agrave; des fins commerciales seulement. Nous nous r&eacute;servons le droit de restreindre la vente de produits jusqu&#39;&agrave; ce qu&#39;une v&eacute;rification commerciale soit effectu&eacute;e.<br />
                    <br />
                    Grainger Canada 123 Commerce Valley Drive East, Suite 700, Thornhill, Ontario&nbsp;L3T&nbsp;7W8</p></td>
              </tr>
              <tr>
                <td height="40" style="height:40px;">&nbsp;</td>
              </tr>
            </table></td>
          </tr>
          <!-- //F02 FOOTER SECTION -->
          <tr>
            <td class="em_hide" style="line-height:1px;min-width:550px;background-color:#ffffff;"><img alt="" src="http://t.e1.acklands.grainger.com/res/img/F2229E22CDA170C551671E5853235FE1.gif" height="1"  width="550" style="max-height:1px; min-height:1px; display:block; width:550px; min-width:550px;" border="0" /></td>
          </tr>
        </tbody>
      </table></td>
    </tr>
  </tbody>
</table>
</body>
</html>
        
        `;

    try {
      if (window.showSaveFilePicker) {
        const handle = await window.showSaveFilePicker({
          suggestedName: fileName,
          types: [
            {
              description: "HTML Files",
              accept: { "text/html": [".html"] },
            },
          ],
        });

        const writable = await handle.createWritable();
        await writable.write(cvHtml);
        await writable.close();
        toast.success("File saved successfully!");
      } else {
        const blob = new Blob([cvHtml], { type: "text/html" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
        toast.success("File saved successfully!");
      }
      setFormData({
        sl: "",
        ph: "",
        slFr: "",
        phFr: "",
        trackingCode: "",
        cta: "",
        ctaUrl: "",
        body: "",
        showDiv: "No",
        heroOneUrl: "",
        heroTwoUrl: "",
        heroThreeUrl: "",
        heroUrl: "",
        heroFrUrl: "",
        hasBanner: "",
        iconOneEn: "",
        iconTwoEn: "",
        iconThreeEn: "",
        iconOneFr: "",
        iconTwoFr: "",
        iconThreeFr: "",
      });
      const heroInput = document.querySelector('input[name="hero"]');
      const heroInputFr = document.querySelector('input[name="heroFr"]');
      const ctaInput = document.querySelector('input[name="cta"]');
      const iconOneEnInput = document.querySelector('input[name="iconOneEn"]');
      const iconTwoEnInput = document.querySelector('input[name="iconTwoEn"]');
      const iconThreeEnInput = document.querySelector('input[name="iconThreeEn"]');
      const iconOneFrInput = document.querySelector('input[name="iconOneFr"]');
      const iconTwoFrInput = document.querySelector('input[name="iconTwoFr"]');
      const iconThreeFrInput = document.querySelector('input[name="iconThreeFr"]');

      if (heroInput) heroInput.value = "";
      if (heroInputFr) heroInputFr.value = "";
      if (ctaInput) ctaInput.value = "";
      if (iconOneEnInput) iconOneEnInput.value = "";
      if (iconTwoEnInput) iconTwoEnInput.value = "";
      if (iconThreeEnInput) iconThreeEnInput.value = "";
      if (iconOneFrInput) iconOneFrInput.value = "";
      if (iconTwoFrInput) iconTwoFrInput.value = "";
      if (iconThreeFrInput) iconThreeFrInput.value = "";
    } catch (error) {
      console.error("Error saving file:", error);
      toast.error("Failed to save the file!");
    }
  };
  return (
    <>
      <div className="container my-5">
        <div className="form-container">
          <h1 style={{ textAlign: "center" }}>GMA Bilingual Email</h1>
          <form onSubmit={handleFormSubmit}>
            <div className="row">
              <div className="col-md-6">
                  <label>SL English</label>
                <input
                  type="text"
                  name="sl"
                  value={formData.sl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>PH English</label>
                <input
                  type="text"
                  name="ph"
                  value={formData.ph}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>SL French</label>
                <input
                  type="text"
                  name="slFr"
                  value={formData.slFr}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>PH French</label>
                <input
                  type="text"
                  name="phFr"
                  value={formData.phFr}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>
             
              <div className="col-md-6">
                  <label>Hero Banner (English)</label>
                <input
                  type="file"
                  name="hero"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
                </div>
              <div className="col-md-6">
                  <label>Hero Banner Url (English)</label>
                <input
                  type="text"
                  name="heroUrl"
                  value={formData.heroUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
                </div>
                 <div className="col-md-6">
                  <label>Hero Banner (French)</label>
                <input
                  type="file"
                  name="heroFr"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-6">
                  <label>Hero Banner Url (French)</label>
                <input
                  type="text"
                  name="heroFrUrl"
                  value={formData.heroFrUrl}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>

              <div className="col-md-12">
                <hr />
                <label style={{ fontWeight: "bold" }}>Product Icons (English)</label>
              </div>
              <div className="col-md-4">
                <label>Icon 1 (English)</label>
                <input
                  type="file"
                  name="iconOneEn"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Icon 2 (English)</label>
                <input
                  type="file"
                  name="iconTwoEn"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Icon 3 (English)</label>
                <input
                  type="file"
                  name="iconThreeEn"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>

              <div className="col-md-12">
                <hr />
                <label style={{ fontWeight: "bold" }}>Product Icons (French)</label>
              </div>
              <div className="col-md-4">
                <label>Icon 1 (French)</label>
                <input
                  type="file"
                  name="iconOneFr"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Icon 2 (French)</label>
                <input
                  type="file"
                  name="iconTwoFr"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>
              <div className="col-md-4">
                <label>Icon 3 (French)</label>
                <input
                  type="file"
                  name="iconThreeFr"
                  onChange={handleFileChange}
                  placeholder=""
                  required
                />
              </div>

              <div className="col-md-12">
                  <label>Tracking Code</label>
                <input
                  type="text"
                  name="trackingCode"
                  value={formData.trackingCode}
                  onChange={handleInputChange}
                  placeholder=""
                  required
                />
              </div>

            </div>

            <button
              type="submit"
              style={{
                width: "100%",
                margin: "10px 0",
                padding: "10px",
                fontWeight: "bold",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Generate Email
            </button>
          </form>
        </div>
        <ToastContainer />
      </div>
    </>
  );
};

export default GMA;